import { render, staticRenderFns } from "./InternalMark.vue?vue&type=template&id=01cfff96&scoped=true"
import script from "./InternalMark.vue?vue&type=script&lang=js"
export * from "./InternalMark.vue?vue&type=script&lang=js"
import style0 from "./InternalMark.vue?vue&type=style&index=0&id=01cfff96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cfff96",
  null
  
)

export default component.exports